import React, { useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import foldToAscii from 'fold-to-ascii';

import { LECTURE_CONTENT_TYPES } from '@classCreation/data/lectureContentTypes';
import LectureContentResourceType from '@classCreation/propTypes/lectureContentResourceType';
import RichTextEditor from 'components/RichTextEditor';
import styles from './LectureContentInput.module.scss';

export default function LectureContentInput({
  contentType,
  value,
  onChange,
  containerClassName,
  ...remainingProps
}) {
  const handleOnChange = useCallback(
    (content) => {
      const _content = foldToAscii.foldReplacing(content, '');
      if (contentType === LECTURE_CONTENT_TYPES.literatureResource) {
        const formattedContent = _content.replace(/<[^>]*>/g, '');
        onChange({
          ...value,
          content: formattedContent,
          content_type: contentType,
        });
      } else {
        onChange({ ...value, content: _content, content_type: contentType });
      }
    },
    [contentType, onChange, value]
  );

  return (
    <RichTextEditor
      containerClassName={classNames(
        styles.editorContainer,
        containerClassName
      )}
      value={value?.content}
      onChange={handleOnChange}
      {...remainingProps}
    />
  );
}

LectureContentInput.propTypes = {
  contentType: PropTypes.oneOf(Object.values(LECTURE_CONTENT_TYPES)),
  value: LectureContentResourceType,
  onChange: PropTypes.func,
  containerClassName: PropTypes.string,
};
